define("shared/utils/string-formatters/camel-to-snake", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f
  /**
   * @module Utils
   */
  /**
   * @class camelToSnake
   * @extends Utils
   */
  /** Returns a snake cased version of the given camel cased string
   *
   * @method camelToSnake
   * @param {String} str Camel cased string
   *
   * @returns {String} Snake cased version of str
   * @protected
   */
  var _default = str => {
    if (typeof str !== 'string') {
      return str;
    }
    return str.replace(/([A-Z])/g, '_$1').toLowerCase().replace(/^_/, '');
  };
  _exports.default = _default;
});